module.exports = __webpack_public_path__ + "media/images/search_w-26b6577d320d58b10902ae47beaffd02.png";